import { FlexRow } from '@framework/ui/components/row/FlexRow.tsx';
import { IconBadge } from '@framework/ui/components/summary/IconBadge.tsx';
import { SummaryTextLabel } from '@framework/ui/components/summary/SummaryTextLabel.tsx';
import { SummaryTextValue } from '@framework/ui/components/summary/SummaryTextValue.tsx';
import { Flex } from 'antd';
import { type IGeneralDataItem } from '../SummaryGeneralDataSection.tsx';

export interface ISummaryGeneralDataItemProps {
  item: IGeneralDataItem;
}

/** Riga del riepilogo dati generali: icona, etichetta e valore */
export function SummaryGeneralDataItem(props: ISummaryGeneralDataItemProps) {
  const { icon, label, children } = props.item;
  return (
    <FlexRow left={icon && <IconBadge icon={icon} />} gutter={16}>
      <Flex vertical>
        <SummaryTextLabel>{label}</SummaryTextLabel>
        <SummaryTextValue>{children}</SummaryTextValue>
      </Flex>
    </FlexRow>
  );
}
